import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { utils } from "../utils/utils";
import api from "../services/api";
import { toast } from "react-toastify";
import toastOptions from "../utils/toastOptions";

declare const UIkit: any;

interface ButtonPrintProps {
  showSecretaryDocs?: boolean;
}

const ButtonPrint = (props: ButtonPrintProps) => {
  const dropdownOptsRef = useRef(null);
  const [isRunningPrint, setRunningPrint] = useState<boolean>(false);

  const handleDownloadDocs = (fileURL: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = fileName;
    link.click();
    UIkit.dropdown(dropdownOptsRef.current).hide();
  }

  const handleMemberReportBlank = async () => {
    setRunningPrint(true);
    try {
      const { data } = await api.get(`members/blank-report`);

      const name = `Ficha de Cadastro-${new Date().getTime()}.pdf`;
      utils.printPDF(name, data.item);
    } catch (e: any) {
      e.messages?.forEach((m: string) => {
        toast.warning(m, toastOptions);
      });
    } finally {
      setRunningPrint(false);
      UIkit.dropdown(dropdownOptsRef.current).hide();
    }
  }

  return <div className="uk-button-group uk-button-small">
    <button 
      id="btn-print"
      className="uk-button uk-button-default uk-button-small" 
      type="button"
    >
      <FontAwesomeIcon className="uk-margin-small-right" icon={faPrint} />
      Impressões
    </button>
    <div className="uk-inline">
      <button
        className="uk-button uk-button-default uk-button-small uk-button-group-toggle" 
        type="button"
      >
        <span uk-icon="icon:triangle-down"></span>
      </button>
      <div uk-dropdown="mode: click; boundary: ! .uk-button-group; boundary-align: true;"
        ref={dropdownOptsRef}>
        <ul className="uk-nav uk-dropdown-nav">
          <li>
            <a href="#" onClick={(ev) => { 
              ev.preventDefault(); 
              handleMemberReportBlank();
            }}
              className='print'>
              {isRunningPrint && <div uk-spinner="true; ratio:0.5"></div>}
              Ficha de Cadastro
            </a>
          </li>
          <li>
            <a href="#" onClick={(ev) => { 
              ev.preventDefault(); 
              handleDownloadDocs('docs/ficha-pedido-recepção.pdf', 'Pedido Recepção Eclesiástica.pdf'); 
            }}
              className='print'>
              Ficha Recepção Eclesiástica
            </a>
          </li>
          {
            props.showSecretaryDocs && <>
              <li>
                <a href="#" onClick={(ev) => { 
                    ev.preventDefault(); 
                    handleDownloadDocs('docs/anexo-obreiro.pdf', 'Anexo Obreiros.pdf'); 
                  }}
                  className='print'>
                  Anexo Obreiros
                </a>
              </li>
              <li>
                <hr className="uk-margin-remove-bottom uk-margin-small-top"/>
                <label className="uk-margin-remove-top">Checklists</label>
              </li>
              <li>
                <a href="#" onClick={(ev) => { 
                    ev.preventDefault(); 
                    handleDownloadDocs('docs/docs-diáconos-presbíteros.pdf', 'Checklist Diáconos e Presbíteros.pdf'); 
                  }}
                  className='print'>
                  Diáconos e Presbíteros
                </a>
              </li>
              <li>
                  <a href="#" onClick={(ev) => { 
                      ev.preventDefault(); 
                      handleDownloadDocs('docs/checklist-diac-presb-secretaria.pdf', 'Checklist Diác e Presb - Secretaria.pdf'); 
                    }}
                    className='print'>
                    Conferência Secretaria Diáconos e Presbíteros
                  </a>
              </li>
              <li>
                  <a href="#" onClick={(ev) => { 
                      ev.preventDefault(); 
                      handleDownloadDocs('docs/checklist-ministros.pdf', 'Checklist Ministros.pdf'); 
                  }}
                      className='print'>
                      Ministros
                  </a>
              </li>
              <li>
                  <a href="#" onClick={(ev) => { 
                      ev.preventDefault(); 
                      handleDownloadDocs('docs/checklist-minstros-secretaria.pdf', 'Checklist Ministros Secretaria.pdf'); 
                    }}
                    className='print'>
                    Ministros Conferência Secretaria
                  </a>
              </li>
            </>
          }
        </ul>
      </div>
    </div>
  </div>
}

export default ButtonPrint;